export function repairUnit(value) {
  if (!value && isNaN(value)) {
    return null
  }
  if (isNumber(value) || isStringNumber(String(value).replace('px', ''))) {
    return isRem() ? pxToRem(value) : repairPx(value)
  } else {
    return value
  }
}

export const isStringNumber = (val) => {
  if (!typeof val === 'string') {
    return false
  }
  return !Number.isNaN(Number(val))
}

export function isRem() {
  const rootStyles = window.getComputedStyle(document.documentElement)
  return rootStyles.getPropertyValue('--KFRAME-CSSTOREM').indexOf('rem') > -1
}

/**
 * @description: 将元素的高宽等像素单位的属性，数字转化为像素字符串
 * @param px 数字或者数字字符串，或者高宽单位（不变返回）。
 * @return: String
 */
export const repairPx = (px) => {
  if (px && !isNaN(px)) {
    return `${px}px`
  }
  return px
}

export function getBaseFontSizeNum() {
  return pxToNum(document.querySelector(':root').style.getPropertyValue('--KFRAME-FONT-SIZE')) || 14
}

/**
 * @description: 将像素单位转化为数字
 * @param px
 * @return: number
 */
export function pxToNum(px) {
  if (!px) {
    return 0
  }
  px = String(px)
  let num = Number(px.replace(/[^\d.]/g, ''))
  if (px.charAt(0) === '-') {
    num = 0 - num
  }
  return num
}

export const pxToRem = (value) => {
  value = pxToNum(value)
  const fontSizeNum = getBaseFontSizeNum()
  return repairRem(value / fontSizeNum)
}

export const repairRem = (rem) => {
  if (rem && !isNaN(rem)) return `${rem}rem`
  return rem
}

function isNumber(obj) {
  return typeof obj === 'number' && !isNaN(obj)
}



// WEBPACK FOOTER //
// ./src/components/SimbartUI/utils/style.js